export default "__VITE_ASSET__2bf90d6d__"